import React from "react";
import api from "src/api";
import {notification} from "antd";

export function useManageItems(items, getItems, onSuccessEdit, openPromoCodeViewDrawer, openYearResult) {
    const [editData, setEditData] = React.useState(null);
    const [userPromoCodes, setUserPromoCodes] = React.useState([]);
    const [userRewards, setUserRewards] = React.useState([]);
    const [isLoadingUserRewards, setIsLoadingUserRewards] = React.useState(false);
    const [yearResultUserId, setYearResultUserId] = React.useState(null)
    const [yearResults, setYearResults] = React.useState([])
    const [userCards, setUserCards] = React.useState([])
    const [isLoadingUserCards, setIsLoadingUserCards] = React.useState(false)

    function onEditItem(id) {
        const item = items.find((item) => item.id === id);
        const newItem = {
            ...item,
            image: item.image !== "null" ? item.image : null,
        };
        setEditData(item);
        onSuccessEdit();
    }

    async function onCreate(data) {
        try {
            await api.post("users/create-client", data);
            notification.success({ message: "Клиент добавлен" });
        } catch (error) {
            console.log("Ошибка создания", error);
            notification.error({ message: "Ошибка создания" });
            throw error;
        } finally {
            getItems();
        }
    }

    async function onSaveEdit(values) {
        try {
            await api.post(`users/${editData.id}`, values);

            notification.success({ message: "Клиент изменён" });

            onSuccessEdit();
            setEditData(false);
        } catch (error) {
            console.log("Ошибка изменения", error);
            notification.error({ message: "Ошибка изменения" });
            throw error;
        } finally {
            getItems();
        }
    }

    async function onDelete(id) {
        try {
            await api.delete(`users/${id}`);
            notification.success({ message: "Клиент удалён" });
        } catch (error) {
            console.log("Ошибка удаления", error);
            notification.error({ message: "Ошибка удаления" });
            throw error;
        } finally {
            getItems();
        }
    }

    async function handleClearDelete(id) {
        try {
            await api.delete(`user-delete/${id}`);
            notification.success({ message: "Клиент полностью удалён" });
        } catch (error) {
            console.log("Ошибка полного удаления", error);
            notification.error({ message: "Ошибка полного удаления" });
            throw error;
        } finally {
            getItems();
        }
    }

    async function handleUserTasksUpdate(id, values) {
        try {
            await api.post(`user-task-update/${id}`, values);
            notification.success({ message: "Задача добавлена" });
        } catch (error) {
            console.log("Ошибка постановки задачи", error);
            notification.error({ message: "Ошибка постановки задачи" });
            throw error;
        } finally {
            getItems();
        }
    }

    async function handleGetYearResults(userId) {
        try {
            const { data } = await api.get(`users/${userId}/characteristics`)
            setYearResults(data.items)
            setYearResultUserId(userId)
            openYearResult()
        } catch (error) {
            notification.error({ message: "Ошибка получения результатов" });
            throw error;
        }
    }

    async function onDeleteSubscriptions(userId) {
        try {
            await api.delete(`users/${userId}/subscriptions`)

            notification.success({ message: "Карты удалены" });
        } catch (error) {
            notification.error({ message: "Ошибка удаления карт" });
            throw error;
        }
    }

    async function getUserCardsAll(userId) {
        setIsLoadingUserCards(true)
        try {
            const { data } = await api.get(`users/${userId}/cards/all`)
            setUserCards(data?.cards ?? [])
            return data?.cards ?? []
        } catch (error) {
            notification.error({ message: "Ошибка получения карт" });
            setUserCards([])
            return []
        } finally {
            setIsLoadingUserCards(false)
        }
    }

    function clearUserCards() {
        setUserCards([])
    }

    async function onDeleteUserSubscription(userId, subscriptionId) {
        try {
            await api.delete(`users/${userId}/subscriptions/${subscriptionId}`)
            notification.success({ message: "Карта удалена" });
        } catch (error) {
            notification.error({ message: "Ошибка удаления карты" });
            throw error;
        }
    }

    function clearYearResults() {
        setYearResultUserId(null)
        setYearResults([])
    }

    async function sendUserPromoCode(values) {
        try {
            await api.post("promo-codes-attach-users", values);

            notification.success({ message: "Промокод отправлек" });
        } catch (error) {
            console.log("Ошибка отправки промокода", error);
            notification.error({ message: "Ошибка отправки промокода" });
            throw error;
        }
    }

    async function getUserPromoCodes(id) {
        try {
            const { data } = await api.get(`user-used-promo-codes/${id}`)
            setUserPromoCodes(data?.promoCodes ?? [] )
            openPromoCodeViewDrawer()
        } catch (error) {

        }
    }

    function clearUserPromoCodes() {
        setUserPromoCodes([])
    }

    async function getUserRewards(userId) {
        setIsLoadingUserRewards(true)
        try {
            const { data } = await api.get(`users/${userId}/rewards`)
            setUserRewards(data?.rewards ?? [])
        } catch (error) {
            notification.error({ message: "Ошибка получения наград" });
            setUserRewards([])
        } finally {
            setIsLoadingUserRewards(false)
        }
    }

    function clearUserRewards() {
        setUserRewards([])
    }


    return {
        editData,
        onEditItem,
        onCreate,
        onSaveEdit,
        onDelete,
        handleClearDelete,
        handleUserTasksUpdate,
        sendUserPromoCode,
        getUserPromoCodes,
        clearUserPromoCodes,
        userPromoCodes,
        getUserRewards,
        clearUserRewards,
        userRewards,
        isLoadingUserRewards,
        handleGetYearResults,
        clearYearResults,
        yearResultUserId,
        yearResults,
        onDeleteSubscriptions,
        getUserCardsAll,
        clearUserCards,
        userCards,
        isLoadingUserCards,
        onDeleteUserSubscription,
    };
}

export function getFormattedItems(items) {
    const data = items.map((item) => ({
        key: item.id,
        id: item.id,
        name: item.dashboardUserInfo?.name ?? null,
        surname: item.dashboardUserInfo?.surname ?? null,
        patronymic: item.dashboardUserInfo?.patronymic ?? null,
        phone: item.phone ?? null,
        email: item.email ?? null,
        birthdayDate: item.dashboardUserInfo?.birthdayDate ?? null,
        sex: item.dashboardUserInfo?.sex ?? null,
        nickname: item.dashboardUserInfo?.nickname ?? null,
        amount: item.dashboardUserInfo?.amount ?? 0,
        bonuses: item.dashboardUserInfo?.bonuses ?? 0,
        isBlocked: item.dashboardUserInfo?.isBlocked ?? false,
        createdAt: item.createdAt,
        deletedAt: item.deletedAt,
    }));

    return data;
}